@if(isAuth) {
  <app-side-menu (onToggleSidenav)="onToggleSidenav($event)"></app-side-menu>
}
<app-body
  [collapsed]="isSideNavCollapsed"
  [screenWidth]="screenWidth"
></app-body>
<!--<router-outlet></router-outlet>-->
